import { useEffect, useContext, useState } from 'react';
import { Dropdown, Image, NavDropdown, Spinner } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { organizationActions } from '../../../actions';
import { TopbarContext } from '../../../contexts/TopbarContext';

function OrganizationDropdown(props) {
  const {
          current_organization,
          organizations,
          loading,
          hidden
        } = props
  const dispatch = useDispatch();
  const [hoveredOrgId, setHoveredOrgId] = useState(null);
  const [isNavOpen, setIsNavOpen] = useState(false);

  const { is_home_page } = useContext(TopbarContext);

  useEffect(() => {
    dispatch(organizationActions.getOrganizations());
  }, []);

  useEffect(() => {
    let timeoutId;
    const delay = 500; // 500ms delay

    if(isNavOpen){
      // Add delay before fetching organizations
      timeoutId = setTimeout(() => {
        dispatch(organizationActions.getOrganizations());
      }, delay);
    } else {
      setHoveredOrgId(null);
    }
    
    return () => {
      clearTimeout(timeoutId);
      setHoveredOrgId(null);
    }
  }, [isNavOpen]);

  const getWorkspaceUrl = (organizationId, workspaceId) => {
    return `/organizations/${organizationId}/workspaces/${workspaceId}/list`;
  }

  const getOrganizationUrl = (organizationId) => {
    return `/organizations/${organizationId}`;
  }

  const handleMouseEnter = (e, orgId) => {
    e.stopPropagation();
    e.preventDefault();

    // Add a delay before setting the hovered organization ID
    const hoverTimer = setTimeout(() => {
      setHoveredOrgId(orgId);
    }, 300); // 300ms delay
    
    // Store the timer in a ref or clean it up on component unmount if needed
    return () => clearTimeout(hoverTimer);
  };
  

  const renderWorkspaces = (organization) => {
    if (organization?.workspaces?.length === 0) {
      return <Dropdown.Item 
                className="workspace- text-muted font-weight-normal d-flex align-items-center"
              >
                No Workspaces Available
            </Dropdown.Item>
    }

    return (
      <>
        {organization.workspaces.map((workspace, idx) => (
          <Dropdown.Item 
            as="a"
            key={'workspace_'+workspace.id}
            className="workspace-item d-flex align-items-center"
            href={getWorkspaceUrl(organization.id, workspace.id)}
            onClick={(e) => {
              e.preventDefault(); 
              window.location.href = getWorkspaceUrl(organization.id, workspace.id);
            }}
          >
            {
              workspace.logo && workspace.logo.thumb.url && (
                <Image src={workspace.logo.thumb.url} className={'mr-lg-2'} style={{ maxWidth: 40, maxHeight: 40, float: "left" }} rounded/>
              )
            }
            <span className="text-truncate">{workspace.name}</span>
          </Dropdown.Item>
        ))}
      </>
    );
  };

  const handleToggle = (isOpen) => {
    setIsNavOpen(isOpen);

    if (!isOpen) {
      setHoveredOrgId(null); // Reset hovered organization when dropdown is closed
    }
  }

  return (
    <NavDropdown
      title={
        <span>
          <span className="dropdown-toggle__text mb-0">
            { current_organization ? current_organization.personal && current_organization.owner ? "My Workspace" : current_organization.name  : 'Select Organization' }
          </span>
        </span>
      }
      id="organization-dropdown"
      className={ "organization-dropdown rounded-corners" + (is_home_page || hidden ? ' d-none' : '') }
      onToggle={handleToggle}
    >
      {
        organizations?.map((data, index) => (
          data?.id !== current_organization?.id && (
            <>
              <Dropdown 
                show={hoveredOrgId === data.id}
                onMouseEnter={(e) => handleMouseEnter(e, data.id)}
                onClick={(e) => handleMouseEnter(e, data.id)}
                drop="end" 
                className="submenu"
                key={'organization_'+data.id}
              >
                <Dropdown.Toggle as="div" className="dropdown-item">
                  {data.personal && data.owner ? "My Workspace" : data.name} 
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  { renderWorkspaces(data) }
                </Dropdown.Menu>
              </Dropdown>
            </>
          )
        ))
      }


      { loading &&
        <div className="spinner-container">
          <Spinner animation="border" />
        </div>
      }
    </NavDropdown>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.organization.loading,
    organizations: state.organization.organizations,
    current_organization: state.organization.current_organization
  };
};

export default connect(mapStateToProps, { })(OrganizationDropdown);
